import React from "react";
import {
  Waves,
  Bone,
  Flower2,
  Droplets,
  Dumbbell,
  CircleDot,
  Hand,
  Leaf,
  Wind,
} from "lucide-react";
import { TREATMENTS } from "../mock";

const iconMap = { Waves, Bone, Flower2, Droplets, Dumbbell, CircleDot, Hand, Leaf, Wind };

const Treatments = () => {
  return (
    <section id="treatments" className="relative bg-white py-24 md:py-32">
      <div className="max-w-[1300px] mx-auto px-6 md:px-10">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#c4a257]" />
            <span className="text-[#c4a257] text-xs tracking-[0.3em] uppercase font-medium">
              What We Offer
            </span>
            <span className="h-px w-10 bg-[#c4a257]" />
          </div>
          <h2 className="font-serif text-[38px] md:text-[54px] leading-tight text-[#1b5e3a]">
            Our <span className="italic text-[#2c7a4a]">Treatments</span>
          </h2>
          <p className="text-[#5a6a5d] mt-5 max-w-2xl mx-auto">
            Personalised naturopathic therapies designed to restore balance and
            unlock your body&apos;s natural capacity to heal.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">
          {TREATMENTS.map((t) => {
            const Icon = iconMap[t.icon];
            return (
              <div
                key={t.title}
                className="group relative overflow-hidden rounded-2xl bg-[#fbf9f4] border border-[#efe7d5] hover:border-[#c4a257]/60 transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_60px_rgba(27,94,58,0.15)]"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={t.image}
                    alt={t.title}
                    className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1b5e3a]/70 via-[#1b5e3a]/10 to-transparent" />
                  <div className="absolute top-4 left-4 w-11 h-11 rounded-full bg-white/95 backdrop-blur flex items-center justify-center shadow-md">
                    <Icon className="w-5 h-5 text-[#1b5e3a]" strokeWidth={1.6} />
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="font-serif text-2xl text-[#1b5e3a] mb-2">
                    {t.title}
                  </h3>
                  <p className="text-sm text-[#5a6a5d] leading-relaxed">
                    {t.subtitle}
                  </p>
                  <div className="mt-5 pt-4 border-t border-[#efe7d5] flex items-center justify-between">
                    <span className="text-[11px] uppercase tracking-[0.2em] text-[#c4a257] font-medium">
                      Naturopathy
                    </span>
                    <span className="text-[#1b5e3a] text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 translate-x-[-6px] group-hover:translate-x-0">
                      Learn more →
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Treatments;
